import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import ReactDatatable from '@ashvin27/react-datatable';

import ReactHover from 'react-hover';

import { withRouter } from 'react-router-dom';



class MarksList extends Component {

  constructor(props) {
    super(props);
    this.columns = [
        {
            key: "titre",
            text: "Type",
            align: "left",
            sortable: true
        }
      ];
      this.config = {
        page_size: 10
      }

      this.options = {
        followCursor:true,
        shiftX: -300,
        shiftY: -80
      }
  }

  

    
    render() {
        return(
          <Fragment>
            <table style={{ width:"100%" }} cellPadding="0" cellSpacing="0">
            <thead>
              <tr>
                <th>Type</th>
                <th>Maker/Metal</th>
                <th>Letters/Numbers</th>
                <th>Outer Shape</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            { this.props.marks.map((markitem)=>{ return(
              <tr key={markitem.id} style={{ cursor: "pointer" }} onClick={()=>this.props.history.push(`/marks/${markitem.id}`)} >
                <td>{ markitem.surtitre }</td>
                <td>{ markitem.titre }</td>
                <td>{ markitem.specs }</td>
                <td>{ markitem.country }</td>
                <td><ReactHover options={this.options}><ReactHover.Trigger type='trigger'><div><img alt="" src={require('../../../assets/img/photo.svg')}  /></div></ReactHover.Trigger><ReactHover.Hover type='hover'><div><img style={{ maxWidth:200}} src={markitem.image} /></div></ReactHover.Hover></ReactHover></td>
              </tr>
            )})}
            </tbody>
            </table>
            </Fragment>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      marks: state.marks.marks
    }
  };

export default connect(mapStateToProps)(withRouter(MarksList));
